export * from "./forbruger-tilknytning.model";
